import { X, Check } from "lucide-react";
import { Reveal, Chapter } from "./shared";

const rows = [
  ["A daily mood, about you alone", "A live read on you and your people"],
  ["Charts you have to interpret", "A clear call you can act on"],
  ["Prediction", "Direction"],
  ["Entertainment", "A tool for your real life"],
];

export const Comparison = () => (
  <section id="why" className="py-16 sm:py-24 lg:py-32 bg-[#F2F0EB] text-[#0B0B0C]" data-testid="comparison-section">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="10" label="The difference" />
      </Reveal>
      <Reveal>
        <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95] mb-10 sm:mb-16" data-testid="comparison-headline">
          Most wellness apps
          <br />
          <span className="text-[#FF4D0A]">vs SOURCECODED.</span>
        </h2>
      </Reveal>
      <Reveal className="border border-[#0B0B0C]/15 overflow-hidden">
        <table className="w-full border-collapse" data-testid="comparison-table">
          <thead>
            <tr className="bg-[#ECEAE3] border-b border-[#0B0B0C]/15">
              <th scope="col" className="w-1/2 p-4 sm:p-5 md:p-7 text-left eyebrow !text-[#8B8E93]">Most wellness apps</th>
              <th scope="col" className="w-1/2 p-4 sm:p-5 md:p-7 text-left eyebrow !text-[#FF4D0A] border-l border-[#0B0B0C]/15">SOURCECODED</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([them, us], i) => (
              <tr key={them} className="border-b border-[#0B0B0C]/15 last:border-b-0 align-top" data-testid={`comparison-row-${i + 1}`}>
                <td className="p-4 sm:p-5 md:p-7">
                  <span className="flex items-start gap-3">
                    <X size={16} className="text-[#8B8E93] mt-0.5 shrink-0" />
                    <span className="text-sm sm:text-base text-[#8B8E93]">{them}</span>
                  </span>
                </td>
                <td className="p-4 sm:p-5 md:p-7 border-l border-[#0B0B0C]/15 bg-[#FF4D0A]/[0.06]">
                  <span className="flex items-start gap-3">
                    <Check size={16} className="text-[#FF4D0A] mt-0.5 shrink-0" />
                    <span className="text-sm sm:text-base text-[#0B0B0C]">{us}</span>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Reveal>
    </div>
  </section>
);
